module.exports = __webpack_public_path__ + "static/img/connectPic.00fb7ffa.png";